import * as logger from '@/lib/logger'

const info = (...args: unknown[]) => {
  logger.info('Onboarding', ...args)
}
const warn = (...args: unknown[]) => logger.warn('Onboarding', ...args)
const error = (...args: unknown[]) => logger.error('Onboarding', ...args)

/** Default to info */
const DEFAULT_LEVEL = info

/**
 * This takes the `DEFAULT_LEVEL` Fn above, and assigns the logging functions as properties
 * (since everything is an object). So, it can be executed as if calling `DEFAULT_LEVEL` and then also
 * still retain reference to all the levels as properties.
 */

/**
 * Logs to the onboarding logging group.
 * Execute to log to `info` level. Or use the specific level desired via properties
 */
export const onboardingLog = Object.assign(DEFAULT_LEVEL, {
  /** Info level logs */
  info,
  /** Warning level logs */
  warn,
  /** Error logging */
  error,
})
